import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { IChargeNumberManagement } from '../../contract-management/IChargeNumberManagement';
import * as fromCNStoreActions from '../../contract-management/store/charge-number-management.actions';
import * as fromCNStoreReducer from '../../contract-management/store/charge-number-management.reducer';
import * as fromDataServices from '../../data-services';
import * as fromLookups from '../../lookups';
import { IUserGroup } from '../../lookups';
import * as fromCommon from '../../shared';
import * as fromShared from '../../shared';
import * as fromUser from '../../user-info';
@Component({
    selector: 'ef-rate-ceiling-feature',
    templateUrl: './rate-ceiling-feature.component.html',
    styleUrls: ['./rate-ceiling-feature.component.scss'],
    standalone: false
})
export class RateCeilingFeatureComponent implements OnInit {
    active = true;

    selectedError$: Observable<fromShared.Errors.IShowErrors>;
    selectedErrorWithStatus$: Observable<fromCommon.IStatusMessage>;
    ShowError = new ReplaySubject<fromShared.Errors.IShowErrors>(1);

    process$: Observable<fromShared.Process>;

    public rateCeilings$: Observable<
        fromDataServices.RateCeiling.RateCeiling[]
    >;
    public contracts$: Observable<fromDataServices.Contract.Contract[]>;
    public chargeNumbers$: Observable<IChargeNumberManagement[]>;
    public costCenters$: Observable<IUserGroup[]>;
    public userInfo$: Observable<fromUser.IUserInfo>;

    rateCeilingDataService: EntityCollectionService<fromDataServices.RateCeiling.RateCeiling>;
    contractDataService: EntityCollectionService<fromDataServices.Contract.Contract>;

    constructor(
        public entityServices: EntityServices,
        private log: fromShared.Services.Logging.LoggingService,
        private store: Store,
        //private rateCeilingCustomDataService: fromDataServices.RateCeiling.RateCeilingDataService
    ) {
        this.rateCeilingDataService =
            entityServices.getEntityCollectionService<fromDataServices.RateCeiling.RateCeiling>(
                fromDataServices.RateCeiling.entityName
            );
        this.contractDataService =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Contract>(
                fromDataServices.Contract.entityName
            );
    }

    ngOnInit(): void {
        this.contractDataService.getAll();
        this.store.dispatch(new fromLookups.LoadUserGroups());

        //getAll default is (activeOnly = true)
        this.rateCeilingDataService.getAll();

        this.setupObservables();
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
        this.rateCeilingDataService.clearCache();
    }

    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.rateCeilings$ = this.rateCeilingDataService.entities$.pipe(
            map(x => clone(x))
        );

        this.costCenters$ = this.store.pipe(
            select(fromLookups.getUserGroupsLookup),
            map(x => (x = x.filter(y => y.PrefixedGroupID.includes('C'))))
        );

        this.chargeNumbers$ = this.store.pipe(
            select(fromCNStoreReducer.selectAll)
            // map(chargenumbers => clone(chargenumbers))
        );

        this.contracts$ = this.contractDataService.entities$.pipe(
            map(x => (x = x.filter(y => y.IsActive === true))),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ContractDesc.localeCompare(b.ContractDesc))
            )
        );

        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
    }

    setupSubscriptions() {
        combineLatest([this.process$, this.ShowError])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });
    }

    onLoadChargeNumbers($event) {
        this.store.dispatch(
            fromCNStoreActions.getChargeNumbers({
                Contract: {
                    ContractListID: $event.toString(),
                    Activeonly: true
                }
            })
        );
    }

    onAddRateCeiling($event) {
        this.log.verbose({
            type: 'RateCeilingFeatureComponent:onAddRateCeiling',
            $event
        });
        this.rateCeilingDataService.getWithQuery($event);
    }

    onSaveRateCeiling($event) {
        this.rateCeilingDataService.upsert($event);
    }

    onDeleteRateCeiling($event) {
        this.rateCeilingDataService.delete($event);
    }

    onIncludeInactiveChecked($event) {
        this.rateCeilingDataService.clearCache();
        this.rateCeilingDataService.getWithQuery({ activeOnly: !$event });
    }
}
